export const countryCodes = [
  { code: '+247', label: 'Ascension Island' },
  { code: '+376', label: 'Andorra' },
  { code: '+971', label: 'United Arab Emirates' },
  { code: '+93', label: 'Afghanistan' },
  { code: '+1-268', label: 'Antigua & Barbuda' },
  { code: '+1-264', label: 'Anguilla' },
  { code: '+355', label: 'Albania' },
  { code: '+213', label: 'Algeria' },
  { code: '+374', label: 'Armenia' },
  { code: '+244', label: 'Angola' },
  { code: '+672', label: 'Antarctica' },
  { code: '+54', label: 'Argentina' },
  { code: '+1-684', label: 'American Samoa' },
  { code: '+43', label: 'Austria' },
  { code: '+61', label: 'Australia' },
  { code: '+297', label: 'Aruba' },
  { code: '+358', label: 'Åland Islands' },
  { code: '+994', label: 'Azerbaijan' },
  { code: '+387', label: 'Bosnia & Herzegovina' },
  { code: '+1-246', label: 'Barbados' },
  { code: '+880', label: 'Bangladesh' },
  { code: '+32', label: 'Belgium' },
  { code: '+226', label: 'Burkina Faso' },
  { code: '+359', label: 'Bulgaria' },
  { code: '+973', label: 'Bahrain' },
  { code: '+257', label: 'Burundi' },
  { code: '+229', label: 'Benin' },
  { code: '+1-441', label: 'Bermuda' },
  { code: '+673', label: 'Brunei' },
  { code: '+591', label: 'Bolivia' },
  { code: '+599', label: 'Caribbean Netherlands' },
  { code: '+55', label: 'Brazil' },
  { code: '+1-242', label: 'Bahamas' },
  { code: '+975', label: 'Bhutan' },
  { code: '+47', label: 'Bouvet Island' },
  { code: '+267', label: 'Botswana' },
  { code: '+375', label: 'Belarus' },
  { code: '+501', label: 'Belize' },
  { code: '+1', label: 'Canada' },
  { code: '+61', label: 'Cocos (Keeling) Islands' },
  { code: '+243', label: 'Congo - Kinshasa' },
  { code: '+236', label: 'Central African Republic' },
  { code: '+242', label: 'Congo - Brazzaville' },
  { code: '+41', label: 'Switzerland' },
  { code: '+225', label: 'Côte d’Ivoire' },
  { code: '+682', label: 'Cook Islands' },
  { code: '+235', label: 'Chad' },
  { code: '+56', label: 'Chile' },
  { code: '+237', label: 'Cameroon' },
  { code: '+86', label: 'China' },
  { code: '+57', label: 'Colombia' },
  { code: '+53', label: 'Cuba' },
  { code: '+238', label: 'Cape Verde' },
  { code: '+599', label: 'Curaçao' },
  { code: '+61', label: 'Christmas Island' },
  { code: '+357', label: 'Cyprus' },
  { code: '+420', label: 'Czechia' },
  { code: '+49', label: 'Germany' },
  { code: '+253', label: 'Djibouti' },
  { code: '+45', label: 'Denmark' },
  { code: '+1-767', label: 'Dominica' },
  { code: '+1-809', label: 'Dominican Republic' },
  { code: '+670', label: 'East Timor (Timor-Leste)' },
  { code: '+593', label: 'Ecuador' },
  { code: '+372', label: 'Estonia' },
  { code: '+20', label: 'Egypt' },
  { code: '+268', label: 'Eswatini' },
  { code: '+212', label: 'Western Sahara' },
  { code: '+291', label: 'Eritrea' },
  { code: '+34', label: 'Spain' },
  { code: '+251', label: 'Ethiopia' },
  { code: '+503', label: 'El Salvador' },
  { code: '+299', label: 'Greenland' },
  { code: '+245', label: 'Guinea-Bissau' },
  { code: '+265', label: 'Malawi' },
  { code: '+674', label: 'Nauru' },
  { code: '+680', label: 'Palau' },
  { code: '+51', label: 'Peru' },
  { code: '+378', label: 'San Marino' },
  { code: '+239', label: 'São Tomé & Príncipe' },
  { code: '+677', label: 'Solomon Islands' },
  { code: '+379', label: 'Vatican City' },
  { code: '+358', label: 'Finland' },
  { code: '+679', label: 'Fiji' },
  { code: '+500', label: 'Falkland Islands' },
  { code: '+691', label: 'Micronesia' },
  { code: '+298', label: 'Faroe Islands' },
  { code: '+33', label: 'France' },
  { code: '+241', label: 'Gabon' },
  { code: '+44', label: 'United Kingdom' },
  { code: '+1-473', label: 'Grenada' },
  { code: '+995', label: 'Georgia' },
  { code: '+594', label: 'French Guiana' },
  { code: '+44-1481', label: 'Guernsey' },
  { code: '+233', label: 'Ghana' },
  { code: '+350', label: 'Gibraltar' },
  { code: '+220', label: 'Gambia' },
  { code: '+224', label: 'Guinea' },
  { code: '+590', label: 'Guadeloupe' },
  { code: '+240', label: 'Equatorial Guinea' },
  { code: '+30', label: 'Greece' },
  { code: '+1-671', label: 'Guam' },
  { code: '+502', label: 'Guatemala' },
  { code: '+592', label: 'Guyana' },
  { code: '+852', label: 'Hong Kong' },
  { code: '+504', label: 'Honduras' },
  { code: '+385', label: 'Croatia' },
  { code: '+509', label: 'Haiti' },
  { code: '+36', label: 'Hungary' },
  { code: '+62', label: 'Indonesia' },
  { code: '+353', label: 'Ireland' },
  { code: '+972', label: 'Israel' },
  { code: '+44-1624', label: 'Isle of Man' },
  { code: '+91', label: 'India' },
  { code: '+964', label: 'Iraq' },
  { code: '+98', label: 'Iran' },
  { code: '+354', label: 'Iceland' },
  { code: '+39', label: 'Italy' },
  { code: '+44-1534', label: 'Jersey' },
  { code: '+1-876', label: 'Jamaica' },
  { code: '+962', label: 'Jordan' },
  { code: '+81', label: 'Japan' },
  { code: '+254', label: 'Kenya' },
  { code: '+996', label: 'Kyrgyzstan' },
  { code: '+855', label: 'Cambodia' },
  { code: '+686', label: 'Kiribati' },
  { code: '+269', label: 'Comoros' },
  { code: '+850', label: 'North Korea' },
  { code: '+82', label: 'South Korea' },
  { code: '+965', label: 'Kuwait' },
  { code: '+7', label: 'Kazakhstan' },
  { code: '+856', label: 'Laos' },
  { code: '+961', label: 'Lebanon' },
  { code: '+1-758', label: 'St. Lucia' },
  { code: '+423', label: 'Liechtenstein' },
  { code: '+94', label: 'Sri Lanka' },
  { code: '+231', label: 'Liberia' },
  { code: '+266', label: 'Lesotho' },
  { code: '+370', label: 'Lithuania' },
  { code: '+352', label: 'Luxembourg' },
  { code: '+371', label: 'Latvia' },
  { code: '+218', label: 'Libya' },
  { code: '+212', label: 'Morocco' },
  { code: '+377', label: 'Monaco' },
  { code: '+373', label: 'Moldova' },
  { code: '+382', label: 'Montenegro' },
  { code: '+261', label: 'Madagascar' },
  { code: '+692', label: 'Marshall Islands' },
  { code: '+389', label: 'North Macedonia' },
  { code: '+223', label: 'Mali' },
  { code: '+95', label: 'Myanmar (Burma)' },
  { code: '+976', label: 'Mongolia' },
  { code: '+853', label: 'Macao' },
  { code: '+1-670', label: 'Northern Mariana Islands' },
  { code: '+230', label: 'Mauritius' },
  { code: '+52', label: 'Mexico' },
  { code: '+60', label: 'Malaysia' },
  { code: '+258', label: 'Mozambique' },
  { code: '+264', label: 'Namibia' },
  { code: '+687', label: 'New Caledonia' },
  { code: '+227', label: 'Niger' },
  { code: '+234', label: 'Nigeria' },
  { code: '+505', label: 'Nicaragua' },
  { code: '+31', label: 'Netherlands' },
  { code: '+47', label: 'Norway' },
  { code: '+977', label: 'Nepal' },
  { code: '+64', label: 'New Zealand' },
  { code: '+968', label: 'Oman' },
  { code: '+507', label: 'Panama' },
  { code: '+595', label: 'Paraguay' },
  { code: '+63', label: 'Philippines' },
  { code: '+92', label: 'Pakistan' },
  { code: '+48', label: 'Poland' },
  { code: '+351', label: 'Portugal' },
  { code: '+1-787', label: 'Puerto Rico' },
  { code: '+974', label: 'Qatar' },
  { code: '+262', label: 'Réunion' },
  { code: '+40', label: 'Romania' },
  { code: '+7', label: 'Russia' },
  { code: '+250', label: 'Rwanda' },
  { code: '+966', label: 'Saudi Arabia' },
  { code: '+221', label: 'Senegal' },
  { code: '+381', label: 'Serbia' },
  { code: '+248', label: 'Seychelles' },
  { code: '+232', label: 'Sierra Leone' },
  { code: '+65', label: 'Singapore' },
  { code: '+421', label: 'Slovakia' },
  { code: '+386', label: 'Slovenia' },
  { code: '+252', label: 'Somalia' },
  { code: '+27', label: 'South Africa' },
  { code: '+211', label: 'South Sudan' },
  { code: '+34', label: 'Spain' },
  { code: '+249', label: 'Sudan' },
  { code: '+597', label: 'Suriname' },
  { code: '+590', label: 'St. Barthélemy' },
  { code: '+46', label: 'Sweden' },
  { code: '+963', label: 'Syria' },
  { code: '+886', label: 'Taiwan' },
  { code: '+992', label: 'Tajikistan' },
  { code: '+255', label: 'Tanzania' },
  { code: '+66', label: 'Thailand' },
  { code: '+228', label: 'Togo' },
  { code: '+690', label: 'Tokelau' },
  { code: '+676', label: 'Tonga' },
  { code: '+1-868', label: 'Trinidad & Tobago' },
  { code: '+216', label: 'Tunisia' },
  { code: '+90', label: 'Türkiye' },
  { code: '+993', label: 'Turkmenistan' },
  { code: '+1-649', label: 'Turks & Caicos Islands' },
  { code: '+1', label: 'United States' },
  { code: '+688', label: 'Tuvalu' },
  { code: '+256', label: 'Uganda' },
  { code: '+380', label: 'Ukraine' },
  { code: '+598', label: 'Uruguay' },
  { code: '+998', label: 'Uzbekistan' },
  { code: '+678', label: 'Vanuatu' },
  { code: '+58', label: 'Venezuela' },
  { code: '+84', label: 'Vietnam' },
  { code: '+681', label: 'Wallis & Futuna' },
  { code: '+967', label: 'Yemen' },
  { code: '+260', label: 'Zambia' },
  { code: '+263', label: 'Zimbabwe' },
];
